export default __webpack_public_path__ + "static/media/chat-empty.86e469f9.svg";